import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentConfig } from '@clooper/core';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-booking-restriction-modal',
  templateUrl: './booking-restriction-modal.component.html',
  styleUrls: ['./booking-restriction-modal.component.scss']
})
export class BookingRestrictionModalComponent implements OnInit {
  public onClose: Subject<boolean>;
  constructor(
    public bsModalRef: BsModalRef,
    public options: ModalOptions,
    private router: Router,
    private config: EnvironmentConfig,

  ) { }

  ngOnInit(): void {
    this.onClose = new Subject();
  }

  close() {
    console.log('this.onClose.next(true)')
    this.onClose.next(true);
    this.bsModalRef.hide();
    
  }
  
  goToEnquiry() {
    this.bsModalRef.hide();
    location.assign(`${this.config.webappUrl}/assisted-booking`);  }

}
